import React, { useState } from "react";
import type { FloatingInputProps } from "./floating-input.types";

type HookArgs = {
    type?: FloatingInputProps["type"];
    numericOnly?: FloatingInputProps["numericOnly"];
    showToggle?: FloatingInputProps["showToggle"] | undefined;
    onKeyDown?: FloatingInputProps["onKeyDown"] | undefined;
};

export const useFloatingInputLogic = ({
    type = "text",
    numericOnly = false,
    showToggle,
    onKeyDown,
}: HookArgs) => {
    const isPasswordField = type === "password";
    const [revealed, setRevealed] = useState(false);
    const effectiveType = isPasswordField && revealed ? "text" : type;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (numericOnly) {
            const ok = /[0-9]/.test(e.key) ||
                ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"]
                    .includes(e.key);
            if (!ok) e.preventDefault();
        }
        if (onKeyDown) onKeyDown(e);
    };

    const shouldShowToggle = typeof showToggle === "boolean"
        ? showToggle
        : isPasswordField;

    return {
        isPasswordField,
        revealed,
        setRevealed,
        effectiveType,
        handleKeyDown,
        shouldShowToggle,
    };
};
